import React, { useState, useEffect } from 'react';
import api from '../../../../../config/axios';
import Swal from 'sweetalert2';

import { FaRegSave, FaTimes } from 'react-icons/fa';

const CartaoModal = ({ cartao, onClose, onCartaoAtualizado }) => {
    const [formData, setFormData] = useState({
        bandeira: '',
        tipo: 'debito',
        conta_bancaria_id: '',
        prazo_dias: 1,
        taxa: '0%',
        taxa_antecipacao: '0%',
        politica_antecipacao: 'nao',
        parcelas: []
    });

    const [contasBancarias, setContasBancarias] = useState([]);
    const [tituloModal, setTituloModal] = useState("");

    const tiposCartao = [
        { value: 'debito', label: 'Débito' },
        { value: 'credito_avista', label: 'Crédito à Vista' },
        { value: 'credito_parcelado', label: 'Crédito Parcelado' }
    ];

    const politicasAntecipacao = [
        { value: 'nao', label: 'Não Antecipar' },
        { value: 'todas', label: 'Antecipar Todas' },
        { value: 'primeira', label: 'Antecipar Primeira' }
    ];

    useEffect(() => {
        loadContasBancarias();

        if (cartao != null) {
            const contaBancariaSelect = cartao.contaBancaria && cartao.contaBancaria.id && cartao.contaBancaria.nome_exibicao ? {
                value: cartao.contaBancaria.id,
                label: cartao.contaBancaria.nome_exibicao
            } : '';

            const parcelasFormatadas = cartao.parcelas ? cartao.parcelas.map(p => ({
                ...p,
                taxa: `${parseFloat(p.taxa || 0).toFixed(2)}%`
            })) : [];

            setFormData({
                bandeira: cartao.bandeira || '',
                tipo: cartao.tipo || 'debito',
                conta_bancaria_id: contaBancariaSelect,
                prazo_dias: cartao.prazo_dias || 1,
                taxa: `${parseFloat(cartao.taxa || 0).toFixed(2)}%`,
                taxa_antecipacao: `${parseFloat(cartao.taxa_antecipacao || 0).toFixed(2)}%`,
                politica_antecipacao: cartao.politica_antecipacao || 'nao',
                parcelas: parcelasFormatadas
            });

            setTituloModal('Editar Cartão');
        } else {
            setTituloModal('Novo Cartão');
        }
    }, [cartao]);

    const loadContasBancarias = async () => {
        try {
            const response = await api.get('/contas-bancarias', { params: { limit: 100 } });
            const options = response.data.records.map(conta => ({
                value: conta.id,
                label: conta.nome_exibicao
            }));
            setContasBancarias(options);
        } catch (error) {
            Swal.fire('Erro', 'Erro ao carregar contas bancárias', 'error');
        }
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        let newValue = type === 'checkbox' ? checked : value;

        if (name === 'tipo') {
            if (newValue === 'credito_parcelado') {
                const parcelasIniciais = Array.from({ length: 23 }, (_, i) => ({
                    parcelas: i + 2,
                    taxa: '0%'
                }));
                setFormData(prev => ({
                    ...prev,
                    [name]: newValue,
                    parcelas: parcelasIniciais
                }));
            } else {
                setFormData(prev => ({
                    ...prev,
                    [name]: newValue,
                    parcelas: []
                }));
            }
        } else if (name === 'taxa' || name === 'taxa_antecipacao') {
            let inputValue = value.replace(/[^0-9.]/g, "");
            if (parseFloat(inputValue) > 100) inputValue = "100";
            if (inputValue !== '') inputValue = inputValue + "%";

            setFormData(prev => ({
                ...prev,
                [name]: inputValue
            }));
        } else {
            setFormData(prev => ({
                ...prev,
                [name]: newValue
            }));
        }
    };

    const handleSelectChange = (name, value) => {
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };


    const handleParcelaChange = (index, value) => {
        let inputValue = value.replace(/[^0-9.]/g, "");
        if (parseFloat(inputValue) > 100) inputValue = "100";
        if (inputValue !== '') inputValue = inputValue + "%";

        const novasParcelas = [...formData.parcelas];
        novasParcelas[index].taxa = inputValue;
        setFormData(prev => ({
            ...prev,
            parcelas: novasParcelas
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.bandeira.trim()) {
            Swal.fire('Erro', 'Bandeira é obrigatória', 'error');
            return;
        }

        if (!formData.conta_bancaria_id || !formData.conta_bancaria_id.value) {
            Swal.fire('Erro', 'Conta bancária é obrigatória', 'error');
            return;
        }


        const parcelasFormatadas = formData.tipo === 'credito_parcelado'
            ? formData.parcelas.map(p => ({
                parcelas: p.parcelas,
                taxa: parseFloat(p.taxa.replace(/[^0-9.]/g, ""))
            }))
            : [];

        const data = {
            bandeira: formData.bandeira.trim(),
            tipo: formData.tipo,
            conta_bancaria_id: formData.conta_bancaria_id.value,
            prazo_dias: parseInt(formData.prazo_dias),
            taxa: parseFloat(formData.taxa.replace(/[^0-9.]/g, "")),
            taxa_antecipacao: parseFloat(formData.taxa_antecipacao.replace(/[^0-9.]/g, "")),
            politica_antecipacao: formData.politica_antecipacao,
            parcelas: parcelasFormatadas
        };

        try {
            Swal.fire({
                title: 'Salvando...',
                allowOutsideClick: false,
                allowEscapeKey: false,
                showConfirmButton: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });

            if (cartao != null) {
                await api.put(`/cartoes/${cartao.id}`, data);
            } else {
                await api.post('/cartoes', data);
            }

            Swal.close();
            Swal.fire('Sucesso', 'Cartão salvo com sucesso!', 'success');
            onCartaoAtualizado();
        } catch (error) {
            Swal.close();
            Swal.fire('Erro', error.response?.data?.message || 'Erro ao salvar cartão', 'error');
        }
    };

    return (
        <div className="modal fade show" tabIndex="-1" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
                <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                    <div className="modal-header">
                        <h4 className="fw-bold mt-2">{tituloModal}</h4>
                        <button type="button" className="btn-close" onClick={onClose} aria-label="Close"></button>
                    </div>

                    <div className="modal-body">
                        <form onSubmit={handleSubmit}>
                            <div className="row">
                                <div className="col-lg-6 col-12">
                                    <label className="form-label fw-bold">Bandeira</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="bandeira"
                                        value={formData.bandeira}
                                        onChange={handleChange}
                                        autoComplete="off"
                                    />
                                </div>
                                <div className="col-lg-6 col-12 mt-lg-0 mt-3">
                                    <label className="form-label fw-bold">Tipo</label>
                                    <select
                                        className="form-select"
                                        name="tipo"
                                        value={formData.tipo}
                                        onChange={handleChange}
                                    >
                                        {tiposCartao.map(tipo => (
                                            <option key={tipo.value} value={tipo.value}>
                                                {tipo.label}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>

                            <div className="row mt-3">
                                <div className="col-12">
                                    <label className="form-label fw-bold">Conta Bancária</label>
                                    <select
                                        className="form-select"
                                        value={formData.conta_bancaria_id?.value || ''}
                                        onChange={(e) => {
                                            const selectedOption = contasBancarias.find(c => c.value === parseInt(e.target.value));
                                            handleSelectChange('conta_bancaria_id', selectedOption || '');
                                        }}
                                    >
                                        <option value="" hidden>Selecione...</option>
                                        {contasBancarias.map(conta => (
                                            <option key={conta.value} value={conta.value}>
                                                {conta.label}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>

                            <div className="row mt-3">
                                <div className="col-lg-4 col-12">
                                    <label className="form-label fw-bold">Prazo (dias)</label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        name="prazo_dias"
                                        value={formData.prazo_dias}
                                        onChange={handleChange}
                                        min="1"
                                        autoComplete="off"
                                    />
                                </div>
                                <div className="col-lg-4 col-12 mt-lg-0 mt-3">
                                    <label className="form-label fw-bold">Taxa (%)</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="taxa"
                                        value={formData.taxa}
                                        onChange={handleChange}
                                        autoComplete="off"
                                        placeholder="0%"
                                    />
                                </div>
                                <div className="col-lg-4 col-12 mt-lg-0 mt-3">
                                    <label className="form-label fw-bold">Taxa Antecipação (%)</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="taxa_antecipacao"
                                        value={formData.taxa_antecipacao}
                                        onChange={handleChange}
                                        autoComplete="off"
                                        placeholder="0%"
                                    />
                                </div>
                            </div>

                            <div className="row mt-3">
                                <div className="col-12">
                                    <label className="form-label fw-bold">Política de Antecipação</label>
                                    <select
                                        className="form-select"
                                        name="politica_antecipacao"
                                        value={formData.politica_antecipacao}
                                        onChange={handleChange}
                                    >
                                        {politicasAntecipacao.map(politica => (
                                            <option key={politica.value} value={politica.value}>
                                                {politica.label}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>

                            {formData.tipo === 'credito_parcelado' && formData.parcelas.length > 0 && (
                                <div className="row mt-4">
                                    <div className="col-12">
                                        <h5 className="fw-bold mb-3">Taxas por Parcela</h5>
                                        <div className="table-responsive" style={{ maxHeight: '300px', overflowY: 'auto' }}>
                                            <table className="table table-striped">
                                                <thead className="table-custom-primary" style={{ position: 'sticky', top: 0, zIndex: 10 }}>
                                                    <tr>
                                                        <th className="text-center" style={{ width: '30%' }}>Parcelas</th>
                                                        <th style={{ width: '70%' }}>Taxa (%)</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {formData.parcelas.map((parcela, index) => (
                                                        <tr key={index}>
                                                            <td className="text-center align-middle">
                                                                <strong>{parcela.parcelas}x</strong>
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    value={parcela.taxa}
                                                                    onChange={(e) => handleParcelaChange(index, e.target.value)}
                                                                    placeholder="0%"
                                                                    autoComplete="off"
                                                                />
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </form>
                    </div>

                    <div className="modal-footer mt-4">
                        <div className="row">
                            <div className="col-12 text-end">
                                <button className="btn btn-outline-danger" type="button" onClick={onClose}>
                                    <FaTimes /> Fechar
                                </button>
                                <button className="btn btn-custom-primary ms-3" type="submit" onClick={handleSubmit}>
                                    <FaRegSave /> Salvar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CartaoModal;